import {Button} from "components/shared/Button";
import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";

// import { copyInput } from "../../utils/clipboard";
import styles from "./TextInput.module.scss";

// TODO

export const TextInput = ({
  children,
  className,
  copyOnly = false,
  disabled = false,
  error = false,
  fullWidth = false,
  icon,
  inputClassName,
  label,
  placeholder,
  refInput,
  size = "Default",
  suffix,
  theme = "Default",
  type = "text",
  value,
  onCancel,
  onChange,
  onClick,
  onKeyDown,
  onOpenNotification,
  onSubmit,
  ...props
}) => {
  let clickHandler = onClick;
  let inputRef; // eslint-disable-line
  let labelElement;

  let keyDownHandler;
  if (onSubmit || onCancel || onKeyDown) {
    keyDownHandler = event => {
      switch (event.key) {
        case "Enter":
          if (onSubmit) {
            const {
              target: { value }
            } = event;

            event.preventDefault();
            onSubmit(value, event);
          }
          break;

        case "Escape":
          if (onCancel) {
            event.preventDefault();
            onCancel(event);
          }
          break;

        default:
          if (onKeyDown) {
            onKeyDown(event);
          }

          break;
      }
    };
  }

  let input = (
    <input
      ref={ref => {
        inputRef = ref;
        if (refInput) {
          refInput(ref);
        }
      }}
      className={classnames(inputClassName, {
        [styles.input]: true
      })}
      disabled={copyOnly || disabled}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange ? event => onChange(event.target.value) : null}
      onKeyDown={keyDownHandler}
      {...props}
    />
  );

  if (label) {
    labelElement = <div className={styles.label}>{label}</div>;
  } else if (icon) {
    labelElement = <div className={styles.icon}>{icon}</div>;
  }

  let suffixLabel;
  if (suffix) {
    suffixLabel = <div className={styles.suffix}>{suffix}</div>;
  }

  let copyElement;
  const copyButtonTheme = theme === "Light" ? "Light" : "";

  if (copyOnly) {
    clickHandler = event => {
      event.preventDefault();

      // const copied = copyInput(inputRef);

      // if (copied) {
      //   onOpenNotification(<p>Link copied!</p>);
      // }

      if (onClick) {
        onClick(event);
      }
    };

    input = <div className={styles.copyInput}>{input}</div>;

    copyElement = (
      <div className={styles.copyButtonContainer}>
        <Button
          className={styles.copyButton}
          type="Chiclet"
          theme={copyButtonTheme}
        >
          Copy
        </Button>
      </div>
    );
  }

  const sizeClass = `size${size}`;
  const styleClass = `theme${theme}`;
  const containerClasses = classnames("controlContainer", className, {
    [styles.copyOnly]: copyOnly,
    [styles.container]: true,
    [styles.disabled]: disabled,
    [styles.error]: error,
    [styles.fullWidth]: fullWidth,
    [styles[sizeClass] || styles.sizeDefault]: true,
    [styles[styleClass] || styles.styleDefault]: true
  });

  return (
    <label className={containerClasses} onClick={clickHandler}>
      {labelElement}
      {input}
      {children}
      {copyElement}
      {suffixLabel}
    </label>
  );
};

TextInput.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  copyOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  icon: PropTypes.node,
  inputClassName: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  refInput: PropTypes.func,
  size: PropTypes.oneOf(["Default", "AltDefault", "Small", "Medium"]),
  suffix: PropTypes.node,
  theme: PropTypes.oneOf([
    "Default",
    "Plain",
    "Search",
    "Flat",
    "Web",
    "Naked",
    "Web-Light",
    "Light",
    "Word"
  ]),
  type: PropTypes.string,
  value: PropTypes.string,
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onOpenNotification: PropTypes.func,
  onSubmit: PropTypes.func
};

// export default TextInput;
